// Filename: src/FooterSmall/index.js
import React from "react";
import * as constants from "../constants";
import { Typography } from "../index";

const FooterSmall = (props) => {
  return (
    <div style={{ marginTop: 50 }}>
      {props.brand === "Ace" ? (
        <Typography style={{ fontSize: 11 }}>
          ©{new Date().getFullYear()} Ace Rental Cars.{" "}
          <a href={constants.HERTZ_PRIVACY_POLICY}>Privacy Policy</a>.
        </Typography>
      ) : props.brand === "Firefly" ? (
        <Typography style={{ fontSize: 11 }}>
          ©{new Date().getFullYear()} Firefly Rent A Car LLC. Firefly is a trademark of Hertz
          Systems, Inc. All rights reserved.{" "}
          <a href={constants.HERTZ_PRIVACY_POLICY}>Privacy Policy</a>.
        </Typography>
      ) : props.brand === "Dollar" ? (
        <Typography style={{ fontSize: 11 }}>
          ©{new Date().getFullYear()} Dollar Car Rental. Dollar is a trademark of Hertz
          Systems, Inc. All rights reserved.{" "}
        </Typography>
      ) : props.brand === "Thrifty" ? (
        <Typography style={{ fontSize: 11 }}>
          ©{new Date().getFullYear()} Thrifty Car Rental. Thrifty is a trademark of Hertz
          Systems, Inc. All rights reserved.{" "}
        </Typography>
      ) : (
        <Typography style={{ fontSize: 11 }}>
          ©{new Date().getFullYear()} The Hertz Corporation. Hertz is committed to your privacy. For
          details, please read our <a href={constants.HERTZ_PRIVACY_POLICY}>Privacy Policy</a>.
        </Typography>
      )}
    </div>
  );
};

export default FooterSmall;
